export namespace ILoggingAction {
  /**
   * Return an instance of ILoggingAction with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ILoggingAction>): ILoggingAction =>
    ({
      parameters: [],
      ...(partial ?? {}),
    }) as ILoggingAction;
}

export interface ILoggingAction {
  event_name: string | undefined;
  /**
   * @protobufOption (faire.common.diffIgnore) = ALWAYS
   */
  parameters: Array<string>;
  existing_normalized_path: string | undefined;
  /**
   * This must be provided by BE and be matching for parent/children we expect to be paired.
   * More context: https://github.com/Faire/mobile/pull/418
   */
  source_event_hash: string | undefined;
  parent_event_name: string | undefined;
}
